export const journalMutationFrag = `
    id
`;

export const journalFrag = `
    id
`;

export const accountFrag = `
    id
    name
    code
`;

export const currencyFrag = `
    id
    name
    code
`;
